import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { useState } from 'react';
import { StyledButton } from '@app/components/button/Button';
import { Empty } from 'antd';

interface DataPoint {
    date: string;
    [key: string]: number | string;
}

interface Series {
    key: string;
    name: string;
    color: string;
}

interface LineChartProps {
    data: DataPoint[];
    series: Series[];
    height?: number;
}

function InteractionsLineChart({ data, series, height = 300 }: Readonly<LineChartProps>) {
    const [hiddenSeries, setHiddenSeries] = useState<Set<string>>(new Set());

    const toggleSeries = (seriesKey: string) => {
        const newHidden = new Set(hiddenSeries);
        if (newHidden.has(seriesKey)) {
            newHidden.delete(seriesKey);
        } else {
            newHidden.add(seriesKey);
        }
        setHiddenSeries(newHidden);
    };

    if (data.length === 0) {
        return (
            <div
                style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Empty description={<p>No data available</p>} />
            </div>
        );
    }

    return (
        <div className="line-chart-wrapper">
            <div className="line-chart-series">
                {series.map((s) => (
                    <StyledButton
                        key={s.key}
                        onClick={() => toggleSeries(s.key)}
                        color="default"
                        shape="round"
                        size="small"
                        className={hiddenSeries.has(s.key) ? 'is-hidden' : 'default'}>
                        <div className="dot" style={{ backgroundColor: s.color }} />
                        {s.name}
                    </StyledButton>
                ))}
            </div>

            <LineChart
                responsive
                style={{
                    width: '100%',
                    height: height,
                    // aspectRatio: 1.618,
                }}
                data={data}>
                <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
                <XAxis dataKey="date" height={60} fontSize={10} angle={-45} textAnchor="end" />
                <YAxis fontSize={10} />
                <Tooltip
                    contentStyle={{
                        backgroundColor: 'rgba(255,255,255,0.9)',
                        border: '1px solid var(--border)',
                        borderRadius: 8,
                        fontSize: 12,
                    }}
                />
                <Legend wrapperStyle={{ fontSize: 12 }} />
                {series.map(
                    (s) =>
                        !hiddenSeries.has(s.key) && (
                            <Line
                                key={s.key}
                                type="monotone"
                                dataKey={s.key}
                                name={s.name}
                                stroke={s.color}
                                strokeWidth={2.5}
                                dot={false}
                                activeDot={{ r: 6, strokeWidth: 2 }}
                                strokeLinejoin="round"
                            />
                        )
                )}
            </LineChart>
        </div>
    );
}

export default InteractionsLineChart;
